const authDe = {
    "sign_in": "anmelden",
    "email": "E-Mail-Adresse",
    "password": "Passwort",
    "sign_in_button": "Anmelden",
    "invalid_credentials": "Ungültige Anmeldeinformationen",
    "password_min_length": "Das Passwort muss mindestens 8 Zeichen lang sein.",
    "passwords_do_not_match": "Die Passwörter stimmen nicht überein.",
    "invalid_token": "Ungültiges Token",
    "password_set": "Passwort festgelegt",
    "confirm_password": "Passwort bestätigen",
    "confirm_title": "Quickpick-Administrator-Registrierungsbestätigung",
    "confirm_text": "Um Ihr Konto einzurichten, benötigen Sie lediglich ein sicheres Passwort.",
    "set_password": "Passwort festlegen",
    "account_activated": "Konto aktiviert",
    "account_activated_text": "Sie können sich nun mit Ihrer angegebenen E-Mail-Adresse und Ihrem Passwort in Ihr Benutzerkonto einloggen.",
    "continue_to_login": "Anmelden",
    "forgotten_password": "Passwort vergessen?",
    "unable_to_reset_password": "Interner Fehler, Passwort konnte nicht zurückgesetzt werden.",
    "reset_password_title": "Passwort zurücksetzen",
    "reset_password_text": "Bitte geben Sie die E-Mail-Adresse ein, die Sie für Ihr Konto verwendet haben. Wir senden Ihnen den Link zum Zurücksetzen Ihres Passworts an diese E-Mail-Adresse.",
    "send_reset_mail": "Link zum Zurücksetzen des Passworts senden",
    "send_reset_mail_success": "An die angegebene Adresse wurde eine E-Mail mit weiteren Anweisungen gesendet.",
    "invalid_email": "Ungültige E-Mail-Adresse",
    "reset_sent": "E-Mail gesendet",
    "change_password_title": "Kennwort ändern",
    "change_password_success": "Passwort erfolgreich geändert",
    "roles": {
        "OWNER": "Administrator",
        "MENU_EDITOR": "Menübearbeitung",
        "STAFF_MANAGER": "Personalmanagement"
    },
    "name": "Name",
    "permissions": "Berechtigungen",
    "create_user_permissions": "Benutzerberechtigungen erstellen",
    "add_restaurant": "Restaurant hinzufügen",
    "user_saved": "Benutzer gespeichert",
    "has_admin_permissions": "Administratorberechtigungen",
    "login_with_google": "Mit Google anmelden",
    "missing_perrmissions": "Sie verfügen nicht über die erforderlichen Berechtigungen, um auf diese Seite zuzugreifen.",
    "qp_signup_title": "QuickPick-Registrierung",
    "qp_signup_text": "Füllen Sie die unten stehenden Felder aus, um ein Benutzerkonto zu erstellen!",
    "user_information": "Benutzerinformationen",
    "restaurant_information": "Restaurantinformationen",
    "restaurant_shortname": "Restaurantkennung",
    "restaurant_name": "Restaurantname",
    "create_profile": "Erstellen",
    "restaurant_name_short": "Der Name des Restaurants muss mindestens 3 Zeichen lang sein.",
    "identifier_example": "Beispielbezeichner",
    "invalid_shortname": "Die Restaurantkennung muss mindestens 3 Zeichen lang sein.",
    "restaurant_shortname_already_in_use": "Restaurantkennung bereits in Verwendung",
    "name_missing": "Name fehlt",
    "signup_failed": "Die Registrierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.",
    "no_restaurant_title": "Für Ihr Konto wurde kein Restaurant ausgewählt.",
    "no_restaurant_text": "Wenn Sie Ihr Konto gerade erst erstellt haben, sollten Sie auch Ihr Restaurant registrieren!",
    "no_restaurant_alt": "Falls Sie Zugang zu einem Restaurant erhalten sollten, wenden Sie sich bitte an den Administrator des Restaurants.",
    "no_user_created_yet": "Sie haben noch kein Konto?",
    "signup_success": "Registrierung erfolgreich",
    "grant_admin_title": "Administratorrechte erteilen",
    "grant_admin_confirmation": "Benutzer mit Administratorrechten können die Restaurant-Einstellungen verwalten, Benutzer hinzufügen und entfernen sowie Abonnements, Zahlungen und Rechnungen verwalten. Für die Bearbeitung der Speisekarte sind keine Administratorrechte erforderlich.",
    "selected_user": "Ausgewählter Benutzer",
    "delete_user_title": "Benutzer entfernen",
    "delete_user_confirmation": "Der ausgewählte Benutzer wird aus dem Restaurant entfernt und hat keinen Zugriff mehr auf die Speisekarte. Diese Aktion kann nicht rückgängig gemacht werden.",
    "admin": "Administrator",
    "activate_account": "Konto aktivieren",
    "account_pending_activation": "Ihr Benutzerkonto wartet auf die Aktivierung.",
    "check_your_activate_email": "Bitte überprüfen Sie Ihren E-Mail-Posteingang und klicken Sie auf den Aktivierungslink.",
    "refresh_page": "Seite aktualisieren",
    "did_not_receive_activation_email": "Ich habe die Aktivierungs-E-Mail nicht erhalten.",
    "activate_tip": "Falls Sie die Aktivierungs-E-Mail nicht finden, überprüfen Sie bitte auch Ihren Spam-Ordner. Sollte sie dort nicht zu finden sein, klicken Sie auf die Schaltfläche unten, um sie erneut zu senden.",
    "resend_email": "Erneut senden",
    "email_resent": "Die Aktivierungs-E-Mail wurde erfolgreich erneut versendet. Bitte überprüfen Sie Ihren E-Mail-Posteingang.",
    "accept_terms_and_conditions": "Ich habe die <a>Allgemeinen Geschäftsbedingungen und die Datenschutzrichtlinie</a> gelesen und akzeptiere sie.",
    "complete_registration": "Vollständige Registrierung",
    "auth_in_progress": "Authentifizierung läuft...",
    "account_successfully_activated": "Ihr QuickPick-Konto wurde erfolgreich aktiviert",
    "continue_to_home_page": "Weiter zur Startseite",
    "invalid_activation": "Bei der Aktivierung des Kontos ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Kundenservice.",
    "activation_mail_sent": "Wir haben mit der Erstellung Ihres Kontos begonnen. Bitte überprüfen Sie Ihren E-Mail-Posteingang und schließen Sie die Registrierung ab, indem Sie auf den Link in der E-Mail klicken."
};

export default authDe;
